"use client"

import { useState } from "react"
import Image from "next/image"
import { Button } from "@/components/ui/button"
import { RevealOnScroll } from "@/components/reveal-on-scroll"

export function AboutSection() {
  const [isExpanded, setIsExpanded] = useState(false)
  return (
    <section id="about" className="py-10 sm:py-24 lg:py-22 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 space-y-16 sm:space-y-20">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-16 items-center">
          <div className="order-last lg:order-first w-full">
            <RevealOnScroll animationClass="animate-slide-in-left">
              <div className="bg-card rounded-3xl shadow-2xl overflow-hidden border border-border">
                <div className="relative w-full h-[300px] sm:h-[360px] lg:h-[420px]">
                  <Image
                    src="/images/building.webp"
                    alt="LOKBHARATI GROUP OF SCHOOLS & COLLEGES campuses"
                    fill
                    priority
                    className="object-cover"
                  />
                </div>
              </div>
            </RevealOnScroll>
          </div>

          <div className="space-y-6 order-first lg:order-last">
            <RevealOnScroll animationClass="animate-slide-in-right">
              <h5 className="text-sm text-muted-foreground">About Our School</h5>
              <h3 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-foreground leading-tight">
                Welcome to Our School of Excellence
              </h3>
              <p className="text-base sm:text-lg md:text-xl text-muted-foreground leading-relaxed">
                Main aim of institution are to educate the illiterate children of the slum and backward areas of Maharashtra.Institution is dedicated to "Sarwa Siksha Abhiyan" to educate one and all of the society.The management of Lokbharti Group of School and College under kailashpuri Seva Samiti, Mumbai (Regd) believes in the motto--"Plan your work and work your plan" It always believes in dreaming and planning.The test of a good teacher is not how many questions he can ask his pupils that they will answer readily, but how many questions he inspires them to ask him which he finds it hard to answer.College has Science, Commerce, Arts Stream.
              </p>


              <div
                className={`grid transition-all duration-500 ease-in-out ${isExpanded ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
              >
                <div className="overflow-hidden">
                  <p className="text-base sm:text-lg md:text-xl text-muted-foreground leading-relaxed pt-4">
                    Our vision extends beyond traditional education; we aim to foster a generation of innovative thinkers and compassionate leaders. By integrating modern technology with time-honored values, we ensure that every student is equipped not just for a career, but for a meaningful life of contribution and service to society. We are committed to continuous growth, adapting our methods to meet the evolving needs of our students and the world they will shape.
                  </p>
                </div>
              </div>

              <div className="pt-2">
                <Button
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="bg-blue-800 hover:bg-blue-900 text-white"
                  size="lg"
                >
                  {isExpanded ? "Read Less" : "Read More"}
                </Button>
              </div>
            </RevealOnScroll>
            {/* <ul className="space-y-3 text-base sm:text-lg text-muted-foreground leading-relaxed">
            <li className="flex items-start gap-3">
              <span className="mt-2 h-2.5 w-2.5 rounded-full bg-primary"></span>
              <span>Systematic and academic approach to meet modern challenges</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-2 h-2.5 w-2.5 rounded-full bg-primary"></span>
              <span>Nurturing intellectual, physical, and spiritual growth</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-2 h-2.5 w-2.5 rounded-full bg-primary"></span>
              <span>Welcoming students from all backgrounds with equal love</span>
            </li>
          </ul> */}
          </div>
        </div>

        {/* <div className="grid lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-16 items-center">
          <div className="space-y-6">
            <h3 className="text-2xl sm:text-3xl font-serif font-bold text-foreground leading-tight text-center sm:text-left">
              Message from Leadership
            </h3>
            <div className="space-y-4 text-base sm:text-lg text-muted-foreground leading-relaxed">
              <p>
                We believe every child carries a unique spark. By blending academic rigor with compassion, we cultivate
                learning environments where curiosity, discipline, and creativity thrive side by side.
              </p>
              <p>
                Our schools and institutes operate as one family—sharing expertise, celebrating achievements, and guiding
                students with unwavering support at every stage of their journey.
              </p>
            </div>
            <ul className="space-y-3 text-base sm:text-lg text-muted-foreground leading-relaxed">
              <li className="flex items-start gap-3">
                <span className="mt-1 h-2.5 w-2.5 rounded-full bg-primary"></span>
                Holistic development with equal focus on academics, values, and life skills.
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-1 h-2.5 w-2.5 rounded-full bg-primary"></span>
                Collaborative mentoring between teachers, parents, and students.
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-1 h-2.5 w-2.5 rounded-full bg-primary"></span>
                Future-ready curriculum supported by technology, arts, and innovation labs.
              </li>
            </ul>
          </div>

          <div className="lg:justify-self-end w-full">
            <div className="bg-card rounded-3xl shadow-2xl overflow-hidden border border-border">
              <div className="relative w-full h-[360px] sm:h-[420px] lg:h-[460px]">
                <Image src="/images/mr-manish-verma.webp" alt="LOKBHARATI GROUP OF SCHOOLS & COLLEGES Leadership" fill priority className="object-cover" />
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 pt-8 sm:pt-12 border-t border-border">
          <div className="text-center p-4 sm:p-6 rounded-2xl bg-card border border-border">
            <div className="text-3xl sm:text-4xl font-serif font-bold text-primary mb-2 sm:mb-3">25+</div>
            <div className="text-xs sm:text-sm font-semibold text-muted-foreground uppercase tracking-wide">
              Years Experience
            </div>
          </div>
          <div className="text-center p-4 sm:p-6 rounded-2xl bg-card border border-border">
            <div className="text-3xl sm:text-4xl font-serif font-bold text-primary mb-2 sm:mb-3">5000+</div>
            <div className="text-xs sm:text-sm font-semibold text-muted-foreground uppercase tracking-wide">
              Students Graduated
            </div>
          </div>
          <div className="text-center p-4 sm:p-6 rounded-2xl bg-card border border-border sm:col-span-2 lg:col-span-1">
            <div className="text-3xl sm:text-4xl font-serif font-bold text-primary mb-2 sm:mb-3">50+</div>
            <div className="text-xs sm:text-sm font-semibold text-muted-foreground uppercase tracking-wide">
              Expert Faculty
            </div>
          </div>
        </div> */}
      </div>
    </section>
  )
}
